<template>
    <div id="AssetLog">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <template v-if="assetLogVal != undefined">
                <div class="bg-white data-table p-0">
                    <vue-good-table
                        ref="listAssetLogTable"
                        mode="remote"
                        title="Log"
                        @on-page-change="onPageChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        :totalRows="totalRecords"
                        :columns="columns"
                        :rows="rows"
                        :pagination-options="{
                            enabled: true,
                            position: 'bottom',
                            perPage: perPage,
                            perPageDropdown:dropDownPerPage,
                            dropdownAllowAll: false,
                        }"
                        >
                    </vue-good-table>
                </div>
        </template>
        <div id="page-content-wrapper" class="admin-content-area" v-else>
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Asset Log List</div>
                        <!-- Button for Clear Cache -->
                        <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                        <a href="javascript:void(0)" class="btn btn-secondary pull-right ml-1" v-on:click="openModal">
                            <i class="fp-import"></i> Import
                        </a>
                        <a href="javascript:void(0)" class="btn btn-secondary pull-right" v-on:click="exportReports()">
                            <i class="fp-export"></i> Export
                        </a>

                    </div>
                <div class="container-fluid">
                    <div class="admin-page-content asset-log-list">
                        <data-table-filter-config :moduleName="'assetLogList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="bg-white data-table">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'assetLogList'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                      ref="listAssetLogTable"
                                      mode="remote"
                                      title="Log"
                                      @on-page-change="onPageChange"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                          enabled: false,
                                          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                          selectionInfoClass: 'custom-class',
                                          selectionText: 'rows selected',
                                          clearSelectionText: 'clear',
                                      }"
                                      >
                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">
                                              <div v-if="props.column.field == 'unit' && canViewAsset === true" class='text-center'>
                                                  <router-link title="View Asset Details" class="color-blue"  v-bind:to="{name: 'AssetView',params:{id:props.row.vehicle_id},query:{from:'log'}}">{{props.row.unit}}</router-link>
                                              </div>
                                              <div v-else>
                                                  {{props.formattedRow[props.column.field]}}
                                              </div>
                                          </div>
                                  </template>
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>



                          <div class="modal fade invoice-modal update-reading-modal" id="myModal" ref="myModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                              <div class="modal-dialog" role="document">
                                  <div class="modal-content">
                                      <div class="modal-header">
                                          <h5 class="modal-title">Select File</h5>
                                      </div>
                                      <div class="modal-body">
                                          <form id="importFile" class="form-inline addinspectionForm basic-form-container">
                                              <div class="form-row">
                                                  <div class="col-md-12 form-group mb-3">
                                                      <label class="control-label require" for="typeImage">File:</label>
                                                      <input id="typeImage" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.template, application/vnd.ms-excel.sheet.macroEnabled.12, application/vnd.ms-excel.template.macroEnabled.12, application/vnd.ms-excel.addin.macroEnabled.12, application/vnd.ms-excel.sheet.binary.macroEnabled.12" @change="onFileChanged">
                                                  </div>
                                                  <span class="field-error">{{error}}</span>
                                              </div>
                                              <div class="form-row">
                                                <div class="col form-group" v-if="fileName != ''">
                                                    <label class="control-label"> Download Sample file </label>
                                                    <a href="javascript:void(0)" v-on:click="downloadSample()"> <i class="fp-text-document"></i> {{fileName}} </a>
                                                </div>
                                              </div>
                                          </form>
                                          <template v-if="notFoundArr.length > 0">
                                              <p class="field-error">{{notValid}}:</p>
                                              <p class="field-error">{{skipped}}:</p>
                                              <template v-for="(unit ,key) in notFoundArr">
                                                  <span :key="key"> {{unit}}<a v-if="key < notFoundArr.length - 1">,</a></span>
                                              </template>
                                          </template>
                                          <template v-if="skipAssetsArr.length > 0">
                                              <p class="field-error">{{notValid}}:</p>
                                              <p class="field-error">{{skipped}}:</p>
                                              <template v-for="(unit ,key) in skipAssetsArr">
                                                  <span :key="key"> {{unit}}<a v-if="key < skipAssetsArr.length - 1">,</a></span>
                                              </template>
                                          </template>
                                      </div>
                                      <div class="modal-footer btm-action-btn-fl">
                                          <!--button v-if="!notfound" class="btn btn-primary" id="myButton" v-on:click="importReport()" > <i class="fp-import"> </i> Import</button>
                                          <button v-if="!notfound" type="button" class="btn btn-tertiary" data-dismiss="modal" ><i class="fp-close"> </i>Cancel</button-->

                                          <button v-if="!notfound" class="btn btn-primary" id="myButton" v-on:click="importReport()" > <i class="fp-import"> </i> Import</button>
                                      <button v-else class="btn btn-primary" id="okbutton" v-on:click="loadList()" data-dismiss="modal">OK</button>
                                      <button v-if="!notfound" type="button" class="btn btn-tertiary" data-dismiss="modal" ><i class="fp-close"> </i>Cancel</button>
                                      <button v-else type="button" class="btn btn-tertiary" v-on:click="loadList()" data-dismiss="modal" > <i class="fp-close"> </i> Cancel</button>
                                      </div>
                                  </div>
                              </div>
                          </div>


                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";


import EventBus from ".././event-bus";


import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
    export default {
        name: "AssetLog",
        mixins:[commonMixins,dataTableMixins],
        props: {
            assetLogVal: {
                type: String,
                required: false,
                default:undefined
            }
        },
        data: () => ({
            notValid:"",
            skipped:"",
            selectedFile:"",
            deviceType:"",
            error:"",
            notfound:false,
            notFoundArr:[],
            skipAssetsArr:[],
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: '# Unit',
                    field: 'unit',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                // {
                //     label: 'Name',
                //     field: 'name',
                //     fpFieldType:"text",
                //     filterable: true,
                //     hidden:false,
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "Name", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                {
                    label: 'Current Location',
                    field: 'old_location',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Assigned Facility", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'New Location',
                    field: 'location',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Assigned Facility", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Location Transfer Date',
                    field: 'location_from_date',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                // {
                //     label: 'Location To',
                //     field: 'location_to_date',
                //     fpFieldType:"date",
                //     filterable: true,
                //     hidden:false,
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "MM/DD/YYYY", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                {
                    label: 'Current Pool',
                    field: 'old_vehicle_pool_id',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Assigned Facility", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'New Pool',
                    field: 'vehicle_pool_id',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Assigned Facility", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Pool Transfer Date',
                    field: 'pool_from_date',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                // {
                //     label: 'Pool To',
                //     field: 'pool_to_date',
                //     fpFieldType:"date",
                //     filterable: true,
                //     hidden:false,
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "MM/DD/YYYY", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                {
                    label: 'Request / Approved By',
                    field: 'updated_by',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Assigned By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            loading:false,
            canViewAsset:false,
            pageKey:"_asset_log_list_",
            action:'list',
            batchProcess:0,
            batchNum:"",
            fileName:'',
        }),
        metaInfo () {
            if (this.assetLogVal == undefined) {
                return {
                    title: "Asset Log List | " +process.env.COPYRIGHT_NAME
                }
            }
        },
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_asset_location_history') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'view_asset') {
                            self.canViewAsset = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },
        beforeDestroy(){
            // this.$root.$off('location_history_opted');
        },
        mounted: function() {
            var self = this;

            // this.$root.$on('asset_log_opted', () => {

            // });

            //when component list directly call from url instead of in view page than call permission request
            if ( self.assetLogVal == undefined ) {
                self.getPermissions();
            }else{
                var path = window.location.pathname;
                var asset = path.split("/");
                self.assetId = asset[3];
                // self.assetLogVal = "loadList";
                self.flag = 'selectedAssetLog';
            }

            // self.loadList();

        },
        methods: {
            importReport: function(){
                var self = this;

                if(self.selectedFile == "" || self.selectedFile == null){
                    self.error = "Please Select Excel File.";
                    return;
                }else{
                    self.error = "";
                }
                var formData = new FormData();
                formData.append('myFile', self.selectedFile);
                // formData.append('fileName', self.selectedFile.name);
                formData.append('fileName', 'VCN DOC');
                // formData.append('device', self.deviceType);

                self.loading = true;
                $('#myButton').text('Fetching...');
                $('#myButton').prop('disabled',true);
                $.ajax({
                    url: process.env.ROOT_API + "/asset-log/import_data",
                    type: "POST",
                    // data: {name: self.name, code: self.code, is_default: self.checkboxValue, id: segments[3]},
                    data: formData,
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success: function (data) {
                        $('#myButton').html('<i class="fp-import"></i>' + 'Import');
                        $('#myButton').prop('disabled',false);
                        self.loading = false;
                        if(data.code == 201){
                            if(data.invalidAssets.length > 0 || data.skipAssets.length > 0){
                                self.notValid = data.failed;
                                self.skipped = data.skip;
                                self.notfound = true;
                                $('#myButton').text('OK');
                                self.notFoundArr = data.invalidAssets;
                                self.skipAssetsArr = data.skipAssets;
                            }else{
                                self.error = data.message;
                            }


                            return;
                        }
                        if (data.status == "success") {
                            self.error = "";
                            if(data.invalidAssets.length > 0){
                                self.notValid = data.failed;
                                self.skipped = data.skip;
                                self.notfound = true;
                                $('#myButton').text('OK');
                                self.notFoundArr = data.invalidAssets;
                                self.skipAssetsArr = data.skipAssets;
                            }else{
                                $('#myModal').modal('hide');
                                self.loadList();
                            }

                        }
                    },
                    error: function (jqXHR, exception) {
                        $('#myButton').html('<i class="fp-import"></i>' + 'Import');
                        $('#myButton').prop('disabled',false);
                      self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'courtesy-notice-import');
                    }
                });
            },
            openModal: function(){
                var self = this;
                self.error = "";
                $('#myButton').html('<i class="fp-import"></i>' + 'Import');
                self.notFoundArr = [];
                self.skipAssetsArr = [];
                self.selectedFile = "";
                self.notfound = false;
                self.generateExcelSample();
                $("#typeImage").val('');
                $('#myModal').modal('show');
            },
            onFileChanged (event) {
                const file = event.target.files[0]

                console.log(event.target);
                var self = this;
                var type = file.type;
                console.log("file = ", type);
                if(type === 'application/vnd.ms-excel'
                || type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.template'
                || type === 'application/vnd.ms-excel.sheet.macroEnabled.12' || type === 'application/vnd.ms-excel.template.macroEnabled.12'
                || type === 'application/vnd.ms-excel.addin.macroEnabled.12' || type === 'application/vnd.ms-excel.sheet.binary.macroEnabled.12') {
                  self.error = "";
                  self.selectedFile = file;
                  self.notfound = false;
                  self.notFoundArr = [];
                  self.skipAssetsArr = [];
                  console.log(self.selectedFile);
                } else {
                  var extention = file.name.split('.').pop();
                  self.error = extention + " is not supporter file type, please select excel";
                }

            },
            cancelAll: function (cancelAll) {
              this.$refs.listAssetLogTable.unselectAllInternal();
            },
            // exportCheck: function() {
            //     var count = 0;
            //     var actionFlag = "";
            //     var data = this.$refs['listAssetLogTable'].selectedRows;
            //     count = data.length;
            //     if(count != 0 && count < 100){
            //       actionFlag = "export";
            //     }
            //     this.exportReports(actionFlag);
            // },

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            loadList() {
                var self = this;

                if ( self.assetLogVal == 'dontLoadList' ){
                    return;
                }

                var selectedRows = [];

                //because on first load list not initialize
                var data = this.$refs['listAssetLogTable'].selectedRows;
                for ( var i = 0; i < data.length; i++ ) {
                    selectedRows.push(this.$refs['listAssetLogTable'].selectedRows[i].id)
                }

                var filterAll = self.serverParams.columnFilters;
                if ( self.action == "export" ) {
                    filterAll = self.removeOptionArr(self.serverParams.columnFilters);
                }
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: filterAll,
                    sort: self.serverParams.sort,
                    flag: self.flag,
                    asset_id: self.assetId,
                    action:self.action,
                    selectedRows:selectedRows
                };
                self.firstLoad = 1;

                $.ajax({
                    url: process.env.ROOT_API + "/asset-log/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            if ( self.action == "export" ||  self.action == "export_queue") {
                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {
                                    if ( self.action == "export" ) {
                                        self.excel = data.content.web;
                                        var save = document.createElement("a");
                                        save.href = self.excel;
                                        save.download = data.content.web;
                                        save.target = "_blank";

                                        document.body.appendChild(save);
                                        save.click();
                                        document.body.removeChild(save);

                                    } else {

                                        self.batchProcess = 1;
                                        self.batchNum = data.content;
                                    }
                                }
                                self.action = "list";
                                // self.loadList();
                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'get-asset-log')
                    }
                });
            },

            generateExcelSample() {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/asset-log-excel/generate",
                    type: "POST",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,
                    success: function(data) {
                        self.loading = false;
                        self.fileName = data.content.file;
                        self.file = data.content.web;

                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'asset-log-upload-generate')

                    }
                });
            },
            downloadSample(){
                var self = this;
                // alert(self.file);
                var docPath = self.file;
                var save = document.createElement('a');
                save.href = docPath;
                save.download = docPath;
                save.target = '_blank';
                document.body.appendChild(save);
                save.click();
                document.body.removeChild(save);
            },
        }
    };
</script>

<style scope>
/* #AssetLocation .vgt-wrap {
    float: none;
} */
</style>



// WEBPACK FOOTER //
// src/components/asset/AssetLog.vue